import React from 'react';
import { Switch } from '@headlessui/react';
import cs from 'classnames';

export const Toggle = React.forwardRef(
    (
        {
            id,
            enabled,
            setEnabled,
            type = 'button',
            variant = 'normal',
            disabled,
            bidirectional,
        }: {
            id?: string;
            enabled: boolean;
            type?: 'button' | 'reset' | 'submit';
            setEnabled: (val: boolean) => void;
            variant?: 'normal' | 'thin';
            disabled?: boolean;
            bidirectional?: boolean;
        },
        ref: React.ForwardedRef<any>,
    ) => {
        const classNamesContainer = cs(
            'relative inline-flex flex-shrink-0 border-2 border-transparent rounded-full cursor-pointer transition-colors ease-in-out duration-200 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-primary disabled',
            {
                ['bg-primary']: enabled || bidirectional,
                ['bg-teal-300']: disabled,
                ['bg-gray-200']: !enabled,
                ['h-6 w-10']: variant === 'normal',
                ['h-4 w-8']: variant === 'thin',
            },
        );
        const classNameSpan = cs(
            'pointer-events-none inline-block h-5 w-5 rounded-full bg-white shadow transform ring-0 transition ease-in-out duration-200',
            {
                ['translate-x-4']: enabled || bidirectional,
                ['-translate-x-2']: !enabled && variant === 'thin',
                ['translate-x-0 -translate-y-0']: !enabled && variant === 'normal',
                ['-mt-1 border border-gray-200']: variant === 'thin',
            },
        );
        return (
            <Switch
                id={id}
                type={type}
                ref={ref}
                disabled={disabled}
                checked={enabled}
                onChange={setEnabled}
                className={classNamesContainer}>
                <span className="sr-only">Use setting</span>
                <span aria-hidden="true" className={classNameSpan} />
            </Switch>
        );
    },
);

Toggle.displayName = 'ToggleComponent';
